import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Button = styled.button`
  padding: 12px 22px;
  font-size: ${fontSize.s};
  color: ${colors.backgroundPrimary};
  background-color: #00000027;
  border: 1px solid ${colors.backgroundPrimary};
  cursor: pointer;
  &:hover {
    background-color: ${colors.backgroundPrimary};
    transition-duration: 0.2s;
    color: ${colors.textPrimary};
  }
`;
function OutlinedButton({ text, onClick, style }) {
  return (
    <Button
      style={style}
      onClick={() => {
        onClick && onClick();
      }}
    >
      {text}
    </Button>
  );
}

export default OutlinedButton;
